// Copyright (c) 2021 WiseTime. All rights reserved.

import React from "react"
import styled from "styled-components/macro"
import AnimatedLoadingIcon from "resources/images/animated_svg/loading-icon.svg?react"

const LoadingIconContainer = styled.div`
  position: fixed;
  top: 84px;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  color: ${({ theme }): string => theme.colors.mercury};
  background-color:${({ theme }): string => theme.colors.wildSand};
  
  @media (min-width: ${({ theme }): string => theme.screen.sm}) {
    position: absolute;
    top: -84px;
  }
  
  @media (min-width: ${({ theme }): string => theme.screen.lg}) {
    top: -94px;
  }
`

const LoadingIcon = styled(AnimatedLoadingIcon)`
  fill: currentColor;
  width: 70px;
  min-width: 70px;
  height: 104px;
`

const LoadingIconWrapper = (): React.ReactElement<unknown> => (
  <LoadingIconContainer>
    <LoadingIcon/>
  </LoadingIconContainer>
)

export default LoadingIconWrapper
